import { commonViewTexts } from '../common';
import { deleteDialogCommonViewTexts } from './delete-dialog-common';

const targetName = commonViewTexts.model;

export const deleteModelDialogViewTexts = {
  title: targetName,
  message: deleteDialogCommonViewTexts.messageGenerator1(targetName)
} as const;
